import { Component, OnInit } from '@angular/core';
import { Lightbox, LightboxConfig } from 'ngx-lightbox';

@Component({
  selector: 'app-work-three',
  templateUrl: './work-three.component.html',
  styleUrls: ['./work-three.component.css']
})
export class WorkThreeComponent implements OnInit {

  ngOnInit(): void {
  }
  album: any = [];
  constructor(private _lightbox: Lightbox, private _lightboxConfig: LightboxConfig) {

    // _lightboxConfig.fadeDuration = 1;


    this.album.push({
      'src': 'assets/img/work/foot-mania/1.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-1.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 1
    });

    this.album.push({
      'src': 'assets/img/work/foot-mania/2.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-2.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 2
    });


    this.album.push({
      'src': 'assets/img/work/foot-mania/3.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-3.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 4
    });

    this.album.push({
      'src': 'assets/img/work/foot-mania/4.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-4.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 3
    });


    this.album.push({
      'src': 'assets/img/work/foot-mania/5.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-5.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 6
    });

    this.album.push({
      'src': 'assets/img/work/foot-mania/6.jpg', 'caption': 'Foot Mania Campaign', 'thumb': 'assets/img/work/foot-mania/thumbs/work-6.jpg',
      'type': 'page', 'link': '/works/foot-mania', "index": 5
    });


    //ascending
    this.album = this.album.sort((a, b) => a.index - b.index);

  }

  open(index: number): void {

    // this._lightbox.open(this.album, index);
    this._lightbox.open(this.album, index, { wrapAround: true, showImageNumberLabel: true, disableScrolling: true, centerVertically: true });
  }

  close(): void {

    this._lightbox.close();
  }
}
